import { BaseRequest } from "./BaseRequest";
import { ICommandResult } from "./models/CommandResult";
import { PRIVATE_CHAT } from "./models/consts";
import { CreateJwtLinkRequest } from "./models/CreateJwtLinkRequest";
import { RecordHistory } from "./models/RecordHistory";
import { Room } from "./models/Room";

export class RoomApiService extends BaseRequest {
    /**
     * Создать комнату
     * @param config
     * @returns
     */
    createRoom(
        config?: Object
    ): Promise<ICommandResult<string>> {
        return this.fetchAPI(
            `/api/Room`,
            Object.assign({method: "POST", body: JSON.stringify({name: "Комната", connectionType: 2})}, config)
        )
            .catch(BaseRequest.handleError);
    }
    
    /**
     * Создать приватный чат
     * @param config
     * @returns
     */
    createPrivateRoom(
        config?: Object
    ): Promise<ICommandResult<string>> {
        return this.fetchAPI(
            `/api/Room`,
            Object.assign({method: "POST", body: JSON.stringify({name: "Личный чат", connectionType: 1, roomType: PRIVATE_CHAT})}, config)
        )
            .catch(BaseRequest.handleError);
    }

    /**
     * Добавить пользователя в чат
     * @param roomId
     * @param userId
     * @param userName
     * @param roomUserTitle
     * @param isVisibleChat
     * @param description
     * @param config
     * @returns
     */
    addUserToPrivateRoom(
        roomId: string,
        userId: any,
        userName: string,
        roomUserTitle: string,
        isVisibleChat: boolean,
        description: string,
        config?: Object
    ): Promise<ICommandResult<string>> {
        return this.fetchAPI(
            `/api/Room/add-user`,
            Object.assign({method: "POST", body: JSON.stringify({roomId, userId, userName, roomUserTitle, isVisibleChat,
                    description, isAdmin: true, systemId: "chatportal", isActive: true})}, config)
        )
            .catch(BaseRequest.handleError);
    }
    
    
    /**
     * Прикласить участника
     * @param config
     * @returns
     */
    createJwtLink(
        request: CreateJwtLinkRequest,
        config?: Object
    ): Promise<ICommandResult<string>> {
        return this.fetchAPI(
            `/api/Room/create-jwt-link`,
            Object.assign({method: "POST", body: JSON.stringify(request)}, config)
        )
            .catch(BaseRequest.handleError);
    }

    /**
     * Получить список записей
     * @param config
     * @returns
     */
    getRecords(
        roomId: any,
        config?: Object
    ): Promise<ICommandResult<RecordHistory[]>> {
        return this.fetchAPI(
            `/api/Room/records`,
            Object.assign({method: "POST", body: JSON.stringify({roomId})}, config)
        )
            .catch(BaseRequest.handleError);
    }

    /**
     * Получение комнату
     * @param roomId
     * @param config
     * @returns
     */
    getRoom(
        roomId: string,
        config?: Object
    ): Promise<ICommandResult<{room: Room}>> {
        return this.fetchAPI(
            `/api/Room/${roomId}`,
            Object.assign({method: "GET"}, config)
        )
            .catch(BaseRequest.handleError);
    }
}